(function () {
  const initProductAccordion = () => {
    $(".about__accordion-toggle").click(function () {
      if (!$(this).hasClass("active")) {
        $(this).addClass("active");
        $(this)
          .siblings(".about__accordion-description")
          .eq($(this).index())
          .stop()
          .slideDown(300);
      } else {
        $(this).removeClass("active");
        $(this).siblings(".about__accordion-description").stop().slideUp(300);
}

    });
  };

  document.addEventListener("shopify:section:load", function () {
    initProductAccordion();
  });

  initProductAccordion();
})();

(function () {
  const initTechnicalSpecifications = (scope = document) => {
    scope.querySelectorAll(".technical-specifications__more").forEach((button) => {
      if (button.dataset.initialized === "true") return;
      button.dataset.initialized = "true";

      button.addEventListener("click", () => {
        const card = button.closest(".technical-specifications");
        const isExpanded = button.getAttribute("aria-expanded") === "true";
        button.setAttribute("aria-expanded", String(!isExpanded));
        card.classList.toggle("technical-specifications--expanded", !isExpanded);
        button.querySelector("[data-more-label]").hidden = !isExpanded;
        button.querySelector("[data-less-label]").hidden = isExpanded;

        if (isExpanded) {
          window.requestAnimationFrame(() => {
            button.scrollIntoView({ behavior: "smooth", block: "center" });
          });
        }
      });
    });
  };

  document.addEventListener("shopify:section:load", (event) => initTechnicalSpecifications(event.target));
  initTechnicalSpecifications();
})();

(function () {
  const positionReviewInformation = (details) => {
    if (!details?.open) return;
    const trigger = details.querySelector(".qeydo-reviews-info__trigger");
    const popover = details.querySelector(".qeydo-reviews-info__popover");
    if (!trigger || !popover) return;

    const isProductPageReview = !details.closest(
      "qeydo-quick-view, .door-compatibility__quick-view"
    );
    const viewportPadding = isProductPageReview ? 16 : 12;
    const gap = isProductPageReview ? 12 : 10;
    const triggerRect = trigger.getBoundingClientRect();
    const popoverRect = popover.getBoundingClientRect();
    const width = Math.min(popoverRect.width, window.innerWidth - viewportPadding * 2);
    const preferredLeft = isProductPageReview
      ? triggerRect.left + triggerRect.width / 2 - width / 2
      : triggerRect.right - width;
    const left = Math.min(
      Math.max(viewportPadding, preferredLeft),
      window.innerWidth - width - viewportPadding
    );
    const spaceAbove = triggerRect.top - viewportPadding;
    const preferredTop = spaceAbove >= popoverRect.height + gap
      ? triggerRect.top - popoverRect.height - gap
      : triggerRect.bottom + gap;
    const top = isProductPageReview
      ? Math.min(
          Math.max(viewportPadding, preferredTop),
          window.innerHeight - popoverRect.height - viewportPadding
        )
      : preferredTop;

    popover.style.setProperty("--qeydo-popover-left", `${Math.round(left)}px`);
    popover.style.setProperty("--qeydo-popover-top", `${Math.round(top)}px`);
  };

  const closeReviewInformation = (exception) => {
    document.querySelectorAll(".qeydo-reviews-info[open]").forEach((details) => {
      if (details !== exception) details.removeAttribute("open");
    });
  };

  document.addEventListener("click", (event) => {
    const details = event.target.closest(".qeydo-reviews-info");
    closeReviewInformation(details);
    if (details) {
      requestAnimationFrame(() => positionReviewInformation(details));
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeReviewInformation();
  });

  const repositionOpenReviewInformation = () => {
    document.querySelectorAll(".qeydo-reviews-info[open]").forEach(positionReviewInformation);
  };

  window.addEventListener("resize", repositionOpenReviewInformation, { passive: true });
  window.addEventListener("scroll", repositionOpenReviewInformation, { passive: true });

  document.addEventListener("click", (event) => {
    const link = event.target.closest('[data-qeydo-reviews-anchor][href^="#"]');
    if (!link) return;
    const target = document.querySelector(link.getAttribute("href"));
    if (!target) return;
    event.preventDefault();
    const stickyHeader = document.querySelector('.shopify-section-header-sticky, .header-wrapper');
    const headerHeight = stickyHeader ? stickyHeader.getBoundingClientRect().height : 0;
    const destination = target.getBoundingClientRect().top + window.scrollY - headerHeight - 16;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, destination), behavior: reduceMotion ? 'auto' : 'smooth' });
  });
})();

(function () {
  const initProgressiveReviews = (scope = document) => {
    scope.querySelectorAll('[data-qeydo-review-list]').forEach((list) => {
      if (list.dataset.progressiveReviewsInitialized === 'true') return;

      const items = Array.from(list.querySelectorAll('[data-qeydo-review-item]'));
      const button = list.querySelector('[data-qeydo-reviews-more]');
      if (!button || items.length <= 3) return;

      list.dataset.progressiveReviewsInitialized = 'true';
      const pageSize = 3;
      let visibleItems = pageSize;
      const label = button.querySelector('[data-qeydo-reviews-more-label]');

      const updateButton = () => {
        const allVisible = visibleItems >= items.length;
        button.setAttribute('aria-expanded', String(allVisible));
        button.classList.toggle('is-expanded', allVisible);
        label.textContent = allVisible ? button.dataset.showLess : button.dataset.showMore;
      };

      button.addEventListener('click', () => {
        const allVisible = visibleItems >= items.length;

        if (allVisible) {
          visibleItems = pageSize;
          items.forEach((item, index) => {
            if (index >= pageSize) item.hidden = true;
          });
          updateButton();

          window.requestAnimationFrame(() => {
            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            list.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
          });
          return;
        }

        const previousVisible = visibleItems;
        visibleItems = Math.min(items.length, visibleItems + pageSize);
        items.forEach((item, index) => {
          if (index >= previousVisible && index < visibleItems) {
            item.hidden = false;
            item.classList.add('is-review-revealing');
            window.setTimeout(() => item.classList.remove('is-review-revealing'), 320);
          }
        });
        updateButton();
      });

      updateButton();
    });
  };

  document.addEventListener('shopify:section:load', (event) => initProgressiveReviews(event.target));
  initProgressiveReviews();
})();

(function () {
  const overlaySelector = [
    'dialog[open]',
    'cart-notification.active',
    '.quick-add-modal[open]',
    '.modal[open]',
    '.qeydo-reviews-info[open]'
  ].join(',');

  const initStickyCart = (scope = document) => {
    scope.querySelectorAll('[data-qeydo-sticky-cart]').forEach((sticky) => {
      if (sticky.dataset.initialized === 'true') return;

      const section = sticky.closest('[id^="MainProduct-"]');
      if (!section || section.closest('qeydo-quick-view, .quick-add-modal, .door-compatibility__quick-view')) return;

      const buyArea = section.querySelector('.product__buy-buttons');
      const primaryButton = buyArea?.querySelector('.product-form__submit');
      const stickyButton = sticky.querySelector('[data-qeydo-sticky-submit]');
      if (!buyArea || !primaryButton || !stickyButton) return;

      sticky.dataset.initialized = 'true';
      const pageMain = section.closest('main') || document.querySelector('main');
      let pagePaddingApplied = false;

      const overlayOpen = () => Boolean(document.querySelector(overlaySelector));
      const updateVisibility = () => {
        const visible = !overlayOpen();
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', String(!visible));
        if (pageMain) {
          if (visible) {
            pageMain.style.setProperty('--qeydo-sticky-cart-space', `${Math.ceil(sticky.getBoundingClientRect().height)}px`);
            pageMain.classList.add('qeydo-sticky-cart-page-space');
            pagePaddingApplied = true;
          } else if (pagePaddingApplied) {
            pageMain.classList.remove('qeydo-sticky-cart-page-space');
            pageMain.style.removeProperty('--qeydo-sticky-cart-space');
            pagePaddingApplied = false;
          }
        }
      };

      const syncButton = () => {
        const sourceLabel = primaryButton.querySelector('span');
        const targetLabel = stickyButton.querySelector('[data-qeydo-sticky-label]');
        if (sourceLabel && targetLabel) targetLabel.innerHTML = sourceLabel.innerHTML;

        const disabled = primaryButton.disabled || primaryButton.getAttribute('aria-disabled') === 'true';
        ['button--primary', 'button--secondary', 'button--tertiary'].forEach((className) => {
          stickyButton.classList.toggle(className, primaryButton.classList.contains(className));
        });
        stickyButton.disabled = disabled;
        stickyButton.setAttribute('aria-disabled', String(disabled));
        stickyButton.classList.toggle('loading', primaryButton.classList.contains('loading'));
        stickyButton.querySelector('.loading-overlay__spinner')?.classList.toggle(
          'hidden',
          !primaryButton.classList.contains('loading')
        );
      };

      stickyButton.addEventListener('click', () => {
        if (!stickyButton.disabled && stickyButton.getAttribute('aria-disabled') !== 'true') {
          primaryButton.click();
        }
      });

      new MutationObserver(syncButton).observe(primaryButton, {
        attributes: true,
        childList: true,
        subtree: true
      });

      document.querySelectorAll('dialog, cart-drawer, cart-notification, .quick-add-modal, .modal, .qeydo-reviews-info')
        .forEach((overlay) => {
          new MutationObserver(updateVisibility).observe(overlay, {
            attributes: true,
            attributeFilter: ['class', 'open']
          });
        });

      document.addEventListener('modalClosed', updateVisibility);
      document.addEventListener('click', () => requestAnimationFrame(updateVisibility));
      syncButton();
      updateVisibility();
    });
  };

  document.addEventListener('shopify:section:load', (event) => initStickyCart(event.target));
  initStickyCart();
})();

// Default product page: reveal the existing Door Compatibility form only when
// the visitor explicitly asks to verify their door.
document.addEventListener(
  'click',
  (event) => {
    const trigger = event.target.closest('[data-open-compatibility]');
    if (!trigger) return;
    const disclosure = document.querySelector(
      '.qeydo-default-product [data-door-compatibility-disclosure]'
    );
    if (disclosure) disclosure.open = true;
  },
  true
);
